import styled from 'styled-components';

export const LoaderSection = styled('section')`
  display: grid;
  align-content: center;
  justify-content: center;
`;
